<!--
 * @Description: 运营总览页面
 * @Author: shh
 * @Date: 2022-07-16 16:43:52
 * @LastEditTime: 2022-09-04 11:01:26
-->
<template>
   <div class="body">
      <!-- 第一部分 -->
      <div class="body-header-list">
        <header-list :overviewTopStatisticsDO="overviewTopStatisticsDO" @handle-jump-page="handleJumpPage"/>
      </div>
      <div class="main-line"></div>
      <!-- 主体部分 -->
      <div class="overview-container">
        <!-- 过滤条件部分 -->
        <el-row >
          <el-col :span="7" style="text-align: left;">
            <span class="search-title">所属机构:</span>
            <el-select size="small" style="width: 240px;"  v-model="filterParams.institutionId" filterable clearable 
              placeholder="请输入/选择" 
              :filter-method="interactionUtil.debounce((value) => 
                commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					    @visible-change="(visible) => 
                commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)">
              <el-option v-for="item in institutionList"  :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-col>
          <el-col :span="7" style="text-align: right;">
            <span :class="toggleIndex == item.id ? 'active' : 'click-switch-list'" @click="mapTimeList(item.id)" 
              v-for="(item,index) in switchData" :key="index">
              {{item.name}}
            </span>
          </el-col>
          <el-col :span="2" class="select" style="text-align: center;">
            <el-dropdown trigger="click" @command="handleCommand"  style="padding: 0;">
              <span class="el-dropdown-link dropdown-style" >
                按日<i class="el-icon-caret-bottom" style="margin-left: 9px;"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="width: 74px; padding: 0; text-align: center;">
                <el-dropdown-item command="a" style="padding: 0;"> 按日</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
          <el-col :span="6" style="text-align: left;">
            <el-date-picker v-model="dateRange" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" 
              unlink-panels range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" size="small"
              :picker-options="dateRangePickerOptions" @change="changeDatePicker" align="right" style="width: 218px;">
            </el-date-picker>
          </el-col>
          <el-col :span="2" style="text-align: right;">
            <el-button size="small" style="height: 30px;"  @click="handleQuery" type="primary" icon="el-icon-search">
              搜 索
            </el-button>
          </el-col>
        </el-row>

        <!--签约机构数(家）用户数(人）订单数(单）订单金额(万元）等.....显示 -->
        <div class="message-items">
          <message-item :cumulativeData="cumulativeData" :instId="filterParams.institutionId" 
            @handle-message-item="handleMessageItem"/>
        </div>
        
        <!-- 订单占比情况/机构订单量Top10/用户消费排名Top10 -->
        <el-row type="flex" :gutter="32" justify="space-between">
          <el-col :span="8" style="padding-left: 15px;">
            <order-pie-charts v-if="orderData.length && orderData.map(item => { return item.value}).every(item => 
              item == 0) == false" :orderData="orderData" id="orderCharts" :orderCount="orderCount"/>
            <empty-data title="订单占比情况" styleHeight="440" v-else/>
          </el-col>
          <el-col :span="8" style="padding-left: 0;">
            <inst-order-volume v-if="institutionOrdersList.length" :institutionOrdersList="institutionOrdersList"/>
            <empty-data title="机构订单量Top10"  styleHeight="440" v-else/>
          </el-col>
          <el-col :span="8" style="padding-left: 0;">
            <user-consumption-ranking v-if="userConsumeList.length" :userConsumeList="userConsumeList"/>
            <empty-data title="用户消费排名Top10"  styleHeight="440" v-else/>
          </el-col>
        </el-row>
        <!-- 注册数变化趋势 -->
        <div style="margin: 15px 0;">
          <el-row  type="flex" :gutter="28" justify="space-between" >
            <el-col :span="24" style="padding-left: 15px;">
              <register-trend-charts v-if="registerChartData.registerNum.length" :registerChartData="registerChartData"
                :registerTrendHeaderData="registerTrendHeaderData"  :registerTabsIndex="registerTabsIndex"
                @handle-register-tabs="handleRegisterTabs"  id="RegisterTrendCharts"/>

              <register-trend-empty-data  v-else :registerTrendHeaderData="registerTrendHeaderData" 
                :registerTabsIndex="registerTabsIndex" @handle-register-tabs="handleRegisterTabs"
                id="RegisterTrendCharts"/>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 画像 -->
      <div style="margin: 15px 40px 15px 40px;" class="view-portrait">    
        <div class="view-portrait-header">
          <span style="font-weight: 600; color: #333333;">画像</span>
          <div class="tabs">
            <span @click="changePortraitTabs(item)" v-for="item in portraitHeaderData" :key="item.id" 
              :class="userTypeIndex == item.id ? 'active-tabs' : 'defaut-active'">
              {{item.name}}
            </span>
          </div>
        </div>
        <el-row  type="flex"  justify="space-between" >
          <el-col :span="12" style="padding-left: 0;">
            <common-pie-charts title="性别" v-if="chartsList.chartData1.length && chartsList.chartData1.map(item => 
              { return item.value}).every(item => item == 0) == false" id="userGenderCharts" 
              :color="chartsList.color1"  :chartData="chartsList.chartData1"  autoresize />
            <el-empty v-else style="margin-top: 40px;" description="暂无数据"></el-empty>
          </el-col>
          <el-col :span="12" style="padding-left: 0;">
            <common-pie-charts title="年龄" v-if="chartsList.chartData2.length && chartsList.chartData2.map(item => 
              { return item.value}).every(item => item == 0) == false" id="userAgeCharts" 
              :color="chartsList.color2"  :chartData="chartsList.chartData2"  autoresize />
            <el-empty v-else style="margin-top: 40px;" description="暂无数据"></el-empty>
          </el-col>
        </el-row>
      </div>
      <!-- 付款数据变化趋势 -->
      <div style="margin: 15px 40px 15px 40px;" class="view-payment-trend"> 
        <div class="view-portrait-header">
          <span style="font-weight: 600; color: #333333;">付款数据变化趋势</span>
        </div>   
        <el-row  type="flex" :gutter="28" justify="space-between" >
          <el-col :span="24" style="padding-left: 0;">
            <payment-trend-charts v-if="PaymentTrendchartData.axiData.length" id="PaymentTrendCharts" 
              :chartData="PaymentTrendchartData"/>
            <el-empty v-else class="empty-img" description="暂无数据"></el-empty>
          </el-col>
        </el-row>
      </div>
   </div>
</template>

<script>
import Util from '@/global/Util.js'
import Constant from '@/global/Constant.js'
import HeaderList from './components/HeaderList.vue'
import MessageItem from './components/MessageItem.vue'
import OrderPieCharts from './components/OrderPieCharts.vue'
import InstOrderVolume from './components/InstOrderVolume.vue'
import UserConsumptionRanking from './components/UserConsumptionRanking.vue'
import RegisterTrendCharts from './components/RegisterTrendCharts.vue'
import RegisterTrendEmptyData from './components/RegisterTrendEmptyData.vue'
import CommonPieCharts from './components/CommonPieCharts.vue'
import PaymentTrendCharts from './components/PaymentTrendCharts.vue'
import EmptyData from  './components/EmptyData.vue'

export default {
  name: 'Overview',
  components: {
    'header-list': HeaderList,
    'message-item': MessageItem,
    'order-pie-charts': OrderPieCharts,
    'inst-order-volume': InstOrderVolume,
    'user-consumption-ranking': UserConsumptionRanking,
    'register-trend-charts': RegisterTrendCharts,
    'common-pie-charts': CommonPieCharts,
    'payment-trend-charts': PaymentTrendCharts,
    'empty-data': EmptyData,
    'register-trend-empty-data': RegisterTrendEmptyData
  },

  data() {
    return {
      filterParams: {
        startDate: Util.getWeekStartDate(),
        endDate: this.dateUtil.dateFormat(new Date()),
      },
      srcInstitutionList: [],
      institutionList: [],//过滤条件选择机构数据
      dateRange: [
        Util.getWeekStartDate(),
        this.dateUtil.dateFormat(new Date())
      ],
			dateRangePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); 
        }
      },
      overviewTopStatisticsDO: {},//获取运营预览顶部

      switchData: [
        {id: 0, name: '今日'},
        {id: 1, name: '本周'},
        {id: 2, name: '本月'},
      ], //切换点击数据
      toggleIndex: 1,//运营预览高亮本周index
      cumulativeData: {},//营预览累积统计数据

      //注册变化趋势数据
      registerTrendHeaderData: [{id: 0, name: '用户注册数'},{id: 1, name: '护工注册数'}],//注册变化趋势tab数据
      registerTabsIndex: 0, //注册变化趋势tab切换默认高亮的index
      registerChartData: {
       'registerNum':[],
       'axiData': []
      },
      
      //付款数据趋势数据
      PaymentTrendchartData: {
       'payList': [],
       'axiData': [],
       'refundList': []
      },

      userTypeIndex: 0,//运营总览画像tab切换默认高亮index
      portraitHeaderData: [{id: 0, name: '用户画像'},{id: 1, name: '护工画像'}],
      
      //饼图画像数据
      chartsList: {
        color1: ['#FAC858','#5470C6', '#91CC75'],
        color2: ['#5470C6', '#91CC75','#FAC858','#EE6666'],
        chartData1: [],
        chartData2: [],
      },
      orderData: [],//订单占比数据
      orderCounts: 123,//订单数量
      orderCount: [],//处理后的订单数量数据
      institutionOrdersList: [],//机构订单top10数据
      userConsumeList: [],//用户消费排名
    }
  },
  
  methods:{
    async initData() {
      this.getTopStatisticsData();
      await this.getOverviewDO();
      this.getContainerData();
    },

    getContainerData() {
      this.getCumulativeData();
      this.getOrderStatisticsChartsData();
      this.getPaidOrderTrendChartsData();
      this.getUserOrAttendantChartsData();
      this.getUserOrAttendantRegistChartsData();
    },

    handleQuery() {
      this.registerTrendHeaderData = (this.filterParams.institutionId == null || this.filterParams.institutionId == '')
        ? [{id : 0, name: '用户注册数'}, {id : 1, name: '护工注册数'}] 
        : [{id : 1, name: '护工注册数'}];
      this.portraitHeaderData = (this.filterParams.institutionId == null || this.filterParams.institutionId == '') 
        ? [{id: 0, name:'用户画像'}, {id: 1, name: '护工画像'}] 
        : [{id: 1, name:'护工画像'}];
      if (!this.dateRange) {
        this.filterParams.startDate = this.getStartDate();
        this.filterParams.endDate = this.toggleIndex !== null ? this.dateUtil.dateFormat(new Date()) : null;
      } else {
        this.filterParams.startDate = this.dateUtil.dateFormat(this.dateRange[0]);
        this.filterParams.endDate = this.dateUtil.dateFormat(this.dateRange[1]);
      }
      if (this.dateRange == null && this.filterParams.startDate == null) {
        this.$message.error( "请先选择搜索时间！");
        return;
      }
      let differDays = Util.getDifferDay(this.filterParams.startDate, this.filterParams.endDate);
      if (differDays > 60) {
        this.$message.error( "最多可选择60天!");
      } else {
        this.getContainerData();
      }
    },

    //获取开始时间
    getStartDate () {
      if (this.toggleIndex == 0) {
        return this.dateUtil.dateFormat(new Date());
      } else if (this.toggleIndex == 1) {
        return Util.getWeekStartDate();
      } else if (this.toggleIndex == 2) {
        return Util.getMonthStartDate();
      } else {
        return null;
      }
    },

    handleCommand(command) {
      console.log(command)
    },

    //获取运营预览顶部统计数据
    getTopStatisticsData() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_OVERVIEW_TOP_STATISTICS_DO).then(result => {
          if (result != null) {
            this.overviewTopStatisticsDO = result.data;
            resolve();
          }
        })
      })
    },

    //获取过滤条件查询运营总览数据DO
    getOverviewDO() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_OVERVIEW_DO).then(result => {
          if (result != null) {
            this.institutionList = result.data;
            this.srcInstitutionList = result.data;
            resolve();
          }
        })
      })
    },

    //获取运营预览累积统计数据
    getCumulativeData() {
      let filterParams = {
        'institutionId' : this.filterParams.institutionId,
        'startDate' : this.filterParams.startDate,
        'endDate' : this.filterParams.endDate,
      };
      let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(filterParams,
        Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_OVERVIEW_CUMULATIVE_DO,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.cumulativeData = result.data;
        }
      })
    },

    //获取运营预览订单统计数据
    getOrderStatisticsChartsData() {
      let filterParams = {
        'institutionId' : this.filterParams.institutionId,
        'startDate' : this.filterParams.startDate,
        'endDate' : this.filterParams.endDate,
      };
      let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(filterParams,
        Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_OVERVIEW_ORDER_STATISTICS_DO,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.orderData = result.data.orderStatusProportionDOList !== null 
            ? result.data.orderStatusProportionDOList : [];
          this.orderCounts =  this.orderData.reduce((sum, e) => sum + Number(e.value || 0), 0);
          this.orderCount = this.orderCounts.toString().split("");
          this.institutionOrdersList = result.data.institutionOrdersList;
          this.userConsumeList = result.data.userConsumeList;
        }
      })
    },

    //获取运营预览付款数据变化趋势DO
    getPaidOrderTrendChartsData() {
      let filterParams = {
        'institutionId' : this.filterParams.institutionId,
        'startDate' : this.filterParams.startDate,
        'endDate' : this.filterParams.endDate,
      };
      let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(filterParams,
        Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_OVERVIEW_PAID_ORDER_TREND,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.PaymentTrendchartData.axiData = result.data !== null ? result.data.dateList : [];
          this.PaymentTrendchartData.payList = result.data !== null ? result.data.payList : [];
          this.PaymentTrendchartData.refundList = result.data !== null ? result.data.refundList : [];
        }
      })
    },

    // 画像tab切换操作
    changePortraitTabs(item) {
      if (this.portraitHeaderData.length == 1)return;
      this.userTypeIndex = item.id;
      this.getUserOrAttendantChartsData();
    },

    //获取运营预览画像用户/护工性别，年龄占比数据 
    getUserOrAttendantChartsData() {
      if (this.portraitHeaderData.length == 2 && this.userTypeIndex == 0) {
        this.filterParams.userType = 'user'
      } else if (this.portraitHeaderData.length == 2 && this.userTypeIndex == 1) {
        this.filterParams.userType = 'attendant'
      } else {
        this.filterParams.userType = 'attendant'
      }
      let header = this.encryptionUtil.signatureParams(this.filterParams,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_USER_OR_ATTENDANT_INFO_STATISTICS_DO,
        param: this.filterParams,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.chartsList.chartData1 = result.data.genderList || [];
          this.chartsList.chartData2 = result.data.ageList || []; 
        }
      })
    },

    //获取运营预览用户/护工注册量占比数据
    getUserOrAttendantRegistChartsData() {
      if (this.registerTrendHeaderData.length == 2 && this.registerTabsIndex == 0) {
        this.filterParams.userType = 'user'
      } else if (this.registerTrendHeaderData.length == 2 && this.registerTabsIndex == 1) {
        this.filterParams.userType = 'attendant'
      } else {
        this.filterParams.userType = 'attendant'
      }
      let header = this.encryptionUtil.signatureParams(this.filterParams,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_USER_OR_ATTENDANT_REGIST_STATISTICS_DO,
        param: this.filterParams,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.registerChartData.axiData = result.data.abscissaList || [];
          this.registerChartData.registerNum = result.data.ordinateList || [];
        }
      })
    },

    handleRegisterTabs(item) {
      this.registerTabsIndex = item.id;
      this.getUserOrAttendantRegistChartsData();
    },

    //点击跳转指定的页面
    handleJumpPage(index) {
      if (index == 0) {
        this.$router.push({name: 'instlist'});
      } else if(index == 1) {
        this.$router.push({name: 'hsplist'});
      }
    },

    handleMessageItem(index) {
      if (index == 0) {
        this.$router.push({name: 'instlist', params: {institutionId: this.filterParams.institutionId}});
      } else if (index == 1) {
        this.$router.push({name: 'resident', params: {begDate: this.filterParams.startDate, endDate: this.filterParams.endDate}});
      } else if (index == 2) {
        this.$router.push({name: 'orderlist', params: {institutionId: this.filterParams.institutionId,
          begDate: this.filterParams.startDate,endDate: this.filterParams.endDate}
        });
      } else if (index == 4) {
        this.$router.push({name: 'hsplist', params: {institutionId: this.filterParams.institutionId}});
      } else if (index == 5) {
        this.$router.push({name: 'atdnlist', params: {institutionId: this.filterParams.institutionId}});
      } else if (index == 6) {
        this.$router.push({name: 'hsvclist', params: {institutionId: this.filterParams.institutionId}});
      }
    },

    mapTimeList(status) {
      this.dateRange = null;
      this.toggleIndex = (status == undefined) ? this.toggleIndex : status;
      this.filterParams.endDate = this.dateUtil.dateFormat(new Date());
      if (this.toggleIndex == 0) {
        this.filterParams.startDate = this.dateUtil.dateFormat(new Date());
      } else if (this.toggleIndex == 1) {
        this.filterParams.startDate = Util.getWeekStartDate();
      } else if (this.toggleIndex == 2) {
        this.filterParams.startDate = Util.getMonthStartDate();
      } else {
        this.filterParams.startDate = '';
      }
      this.dateRange =  [this.filterParams.startDate, this.filterParams.endDate];
    },

    changeDatePicker(date) {
      if (date == null) return;
      let differDays = Util.getDifferDay(date[0],date[1]);
      if (differDays > 60) {
        this.$message.error( "最多可选择60天!");
      } else {
        this.toggleIndex = date !== null ? null : 1;
      }
    }
  },

  mounted() {
    this.$emit("breadcrumb", {	text1: '运营总览'});
    this.initData();
  }
}
</script>
<style >
.overview-container .el-dropdown-menu .el-dropdown-menu__item {
 line-height: 12px !important;
}
</style>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.body-header-list {
  margin: 30px 40px;
}

.main-line {
  height: 10px;
  background-color: #f2f3f4;
}

.overview-container {
  margin: 35px 40px 15px 40px;
}

.search-title {
  font-size: 14px;
  font-weight: 400;
  color: #657180;
  margin-right: 9px;
}

.click-switch-list {
  display: inline-block;
  width: 96px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border: 1px solid #D7DDE5;
  color: #657180;
  cursor:pointer;
}

.active {
  display: inline-block;
  width: 96px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border: 1px solid #3E7EF5;
  background-color:  #3E7EF5;
  color: #FFFFFF;
  cursor:pointer;
}

.view-portrait {
  height: 531px;
  border-radius: 6px;
  border: 1px solid #D7DDE5;
}

.view-portrait-header {
  display: flex;
  justify-content: space-between;
  height: 46px;
  line-height: 46px;
  padding: 0 20px;
  border-bottom: 1px solid #D7DDE5;
}

.tabs :nth-child(1) {
  margin-right: 30px;
}

.active-tabs {
  font-size: 16px;
  color: #3E7EF5;
  display: inline-block;
  height: 38px;
  border-bottom: 3px solid #3E7EF5;
  cursor: pointer;
}

.defaut-active {
  font-size: 16px;
  color: #666666;
  display: inline-block;
  height: 44px;
  cursor: pointer;
}

.dropdown-style {
  width: 74px;
  height: 28px;
  line-height: 28px;
  border-radius: 4px;
  border: 1px solid #D7DDE5;
  display:inline-block;
}

.view-payment-trend {
  height: 344px;
  border-radius: 6px;
  border: 1px solid #D7DDE5;
}
</style>


// WEBPACK FOOTER //
// src/components/overview/Overview.vue